<main id="main" class="clearfix">
  <div class="fusion-row">
    <section id="content" style="width: 100%">
      <div
        id="post-2232"
        class="post-2232 page type-page status-publish hentry"
      >
        <span class="entry-title rich-snippet-hidden"
          >Feedback Ringraziamento</span
        ><span class="vcard rich-snippet-hidden"
          ><span class="fn"
            ><a
              href="http://test.skimmingitalia.it/author/admin/"
              title="Articoli scritti da admin"
              rel="author"
              >admin</a
            ></span
          ></span
        ><span class="updated rich-snippet-hidden"
          >2021-06-11T10:15:06+02:00</span
        >

        <div class="post-content">
          <div
            class="
              fusion-fullwidth
              fullwidth-box
              fusion-builder-row-1
              nonhundred-percent-fullwidth
              non-hundred-percent-height-scrolling
            "
            style="
              background-color: rgba(255, 255, 255, 0);
              background-position: center center;
              background-repeat: no-repeat;
              padding-top: 0px;
              padding-right: 0px;
              padding-bottom: 0px;
              padding-left: 0px;
            "
          >
            <div class="fusion-builder-row fusion-row">
              <div
                class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_1
                  fusion-builder-column-0
                  fusion-one-full
                  fusion-column-first
                  fusion-column-last
                  1_1
                "
                style="margin-top: 0px; margin-bottom: 0px"
              >
                <div
                  class="fusion-column-wrapper"
                  style="
                    padding: 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    background-size: cover;
                    height: auto;
                  "
                  data-bg-url=""
                >
                  <div class="fusion-text">
                    <h1
                      style="
                        text-align: center;
                        --fontSize: 50;
                        line-height: 1.4;
                      "
                      data-fontsize="50"
                      data-lineheight="70px"
                      class="fusion-responsive-typography-calculated"
                    >
                      Grazie per il tuo feedback!
                    </h1>
                  </div>
                  <div class="fusion-button-wrapper fusion-aligncenter">
                    <style type="text/css">
                      .fusion-button.button-1 {
                        border-radius: 0px;
                      }</style
                    ><a
                      class="
                        fusion-button
                        button-flat
                        fusion-button-default-size
                        button-default button-1
                        fusion-button-default-span fusion-button-default-type
                      "
                      target="_self"
                      href="http://test.skimmingitalia.it/"
                      ><span class="fusion-button-text"
                        >TORNA ALLA HOME</span
                      ></a
                    >
                  </div>
                  <div
                    class="fusion-separator fusion-full-width-sep sep-none"
                    style="
                      margin-left: auto;
                      margin-right: auto;
                      margin-top: 50px;
                    "
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <style type="text/css">
            .fusion-fullwidth.fusion-builder-row-1
              a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
            .fusion-fullwidth.fusion-builder-row-1
              a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
            .fusion-fullwidth.fusion-builder-row-1
              a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
              color: #ffa626;
            }
            .fusion-fullwidth.fusion-builder-row-1
              a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
            .fusion-fullwidth.fusion-builder-row-1
              a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
            .fusion-fullwidth.fusion-builder-row-1
              a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
              color: #ffa626;
            }
            .fusion-fullwidth.fusion-builder-row-1 .pagination a.inactive:hover,
            .fusion-fullwidth.fusion-builder-row-1
              .fusion-filters
              .fusion-filter.fusion-active
              a {
              border-color: #ffa626;
            }
            .fusion-fullwidth.fusion-builder-row-1 .pagination .current {
              border-color: #ffa626;
              background-color: #ffa626;
            }
            .fusion-fullwidth.fusion-builder-row-1
              .fusion-filters
              .fusion-filter.fusion-active
              a,
            .fusion-fullwidth.fusion-builder-row-1
              .fusion-date-and-formats
              .fusion-format-box,
            .fusion-fullwidth.fusion-builder-row-1 .fusion-popover,
            .fusion-fullwidth.fusion-builder-row-1 .tooltip-shortcode {
              color: #ffa626;
            }
            #main
              .fusion-fullwidth.fusion-builder-row-1
              .post
              .blog-shortcode-post-title
              a:hover {
              color: #ffa626;
            }
          </style>
        </div>
      </div>
    </section>
  </div>
  <!-- fusion-row -->
</main>
